import React from 'react';
import _ from 'lodash';
import { OZEMPIC_DESC, PRESCRIPTION_CANONICAL } from '../../constants/defaults';

export const getLdJson = (
  drugName,
  drugInfo,
  drugStructure,
  lowestPrice,
  replaceableVariables
) => {
  let structuredData;
  let genericName = '';
  if (
    drugStructure &&
    !_.isEmpty(drugStructure.defaultKey) &&
    drugStructure.defaultKey.isGeneric
  ) {
    genericName = drugStructure.defaultKey.name;
  }
  if (!_.isEmpty(drugInfo)) {
    let desc = _.setSEOVariables(
      drugInfo.drug.treatment,
      lowestPrice,
      replaceableVariables
    );
    structuredData = {
      '@context': 'http://schema.org',
      '@type': 'Drug',
      name: drugInfo.cmsData.name,
      url: `${PRESCRIPTION_CANONICAL}${drugName}/${drugName}-coupons`,
      drugClass: getDrugsClasses(drugInfo),
      prescriptionStatus: 'http://schema.org/PrescriptionOnly',
      administrationRoute: drugInfo.drug.form,
      availableStrength: drugInfo.drug.imageUrl,
      nonProprietaryName:
        drugInfo?.cmsData?.name === 'Ozempic' ? 'Semaglutide' : genericName,
      description:
        drugInfo?.cmsData?.name === 'Ozempic'
          ? OZEMPIC_DESC
          : (desc && desc.replace('<br><br>', ' ')) || '',
      image: drugInfo.imageUrl,
      mainEntityOfPage: {
        '@id': `https://www.singlecare.com/prescription/${drugName}/${drugName}-coupons`,
        '@type': 'WebPage',
        name: `${drugInfo?.cmsData?.name} coupons`
      },
      relatedDrug: getRelatedDrugs(drugInfo),
      '@graph': getGraphs(drugInfo)
    };
  }
  return JSON.stringify(structuredData);
};

const getDrugsClasses = drugInfo => {
  let drugClasses = [];
  if (!_.isEmpty(drugInfo?.monoGraphData?.therapeuticClasses)) {
    drugInfo.monoGraphData.therapeuticClasses.forEach(function (classItem) {
      let DrugClass = {
        '@type': 'DrugClass',
        name: classItem
      };
      drugClasses.push(DrugClass);
    });
  } else if (!_.isEmpty(drugInfo?.cmsData?.drugClasses)) {
    drugInfo?.cmsData?.drugClasses.forEach(item => {
      let DrugClass = {
        '@type': 'DrugClass',
        name: item?.name
      };
      drugClasses.push(DrugClass);
    });
  }
  return drugClasses;
};

const getGraphs = drugInfo => {
  let graphs = [];

  if (!_.isEmpty(drugInfo?.monoGraphData?.indications)) {
    drugInfo.monoGraphData.indications.forEach(function (indication) {
      let graph = {
        '@type': 'MedicalCondition',
        name: indication
      };
      graphs.push(graph);
    });
  } else if (!_.isEmpty(drugInfo?.cmsData?.relatedConditions)) {
    drugInfo?.cmsData?.relatedConditions.forEach(item => {
      let graph = {
        '@type': 'MedicalCondition',
        name: item?.title,
        Drug: {
          name: drugInfo.cmsData.name
        }
      };
      graphs.push(graph);
    });
  }
  return graphs;
};

const getRelatedDrugs = drugInfo => {
  let relatedDrugs = [];
  if (drugInfo && drugInfo.relatedDrugs) {
    drugInfo.relatedDrugs.forEach(function (relatedDrug) {
      let relatedItem = {
        '@type': 'Drug',
        name: relatedDrug.drugName,
        url: `${PRESCRIPTION_CANONICAL}${relatedDrug.seoName}/${relatedDrug.seoName}-coupons`
      };
      relatedDrugs.push(relatedItem);
    });
  }
  return relatedDrugs;
};

export const setMetaContent = drugInfo => {
  if (drugInfo && drugInfo.cmsData && drugInfo.cmsData.metaRobotsNoindex)
    return (
      <meta name="ROBOTS" content="NOINDEX, FOLLOW, NOSNIPPET, NOODP, NOYDIR" />
    );
};
